type LogoutApplication = {
  urlCallback?: string;
  urlSite?: string;
};

const safeHttpUrl = (value?: string | null): URL | null => {
  if (!value) return null;
  try {
    const url = new URL(value);
    return url.protocol === "https:" || url.protocol === "http:" ? url : null;
  } catch {
    return null;
  }
};

export const resolveLogoutReturnUrl = (
  requestedReferer: string | null | undefined,
  application: LogoutApplication | null | undefined
): string | null => {
  const approved = [application?.urlCallback, application?.urlSite]
    .map(safeHttpUrl)
    .filter((value): value is URL => Boolean(value));
  if (approved.length === 0) return null;

  const requested = safeHttpUrl(requestedReferer);
  if (requested && approved.some((url) => url.origin === requested.origin)) {
    return requested.toString();
  }

  return approved[0].toString();
};
